import React from 'react';

import './DeleteFail.scss';
import {useDispatch} from 'react-redux';
import {
  AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL,
  closeModal,
} from '../../../redux/modules/modals/modals.module';
import {TOLL_FREE_NUMBER} from '../../../settings/settings';
import Phone from '../../Phone/Phone';

const DeleteFail = () => {
  const dispatch = useDispatch();

  return (
    <div>
      <div className="defer-delete-fail-title">
        We were unable to process your request.
      </div>
      <div className="defer-delete-fail-subTitle">
        Please call us at <Phone phoneNumber={TOLL_FREE_NUMBER} /> to proceed
      </div>
      <div className="defer-delete-fail-button-container">
        <button
          className="defer-delete-fail-button"
          buttontype="primary"
          stylename="defer-delete-fail-button"
          disabled={false}
          id="delete-btn"
          onClick={() =>
            dispatch(closeModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL))
          }
        >
          Ok
        </button>
      </div>
    </div>
  );
};

export default DeleteFail;
